export const CHECKOUT_SESSION_KEYS = {
  appId: 'checkout_app_id',
  quoteId: 'checkout_quote_id',
  paymentPlanId: 'checkout_payment_plan_id',
} as const;

export const TOKEN_ERROR_MESSAGES: Record<string, string> = {
  expired: 'This link has expired. Please contact your agent for a new link.',
  invalidated:
    'Your agent has made changes to your application. Please check your messages for an updated checkout link.',
  locked: 'Too many attempts. Please try again in 15 minutes.',
  error: 'Something went wrong. Please try again later.',
};

export const BIND_ERROR_MESSAGES = {
  quoteChange: 'Your quote has been updated. Please refresh to get updates.',
  uwHardStop: 'Something went wrong. Please contact your agent.',
} as const;

export const BIND_DECISION_MESSAGES: Record<string, string> = {
  quote_change: BIND_ERROR_MESSAGES.quoteChange,
  uw_hard_stop: BIND_ERROR_MESSAGES.uwHardStop,
};
